var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0093 13.045L12.0005 13.0361L11.9916 13.045L6.91854 18.118C6.78256 18.254 6.6117 18.3237 6.40508 18.3269C6.19878 18.3301 6.02483 18.2605 5.88241 18.118C5.73989 17.9755 5.66875 17.8031 5.66875 17.6C5.66875 17.3969 5.73989 17.2244 5.88241 17.0819L10.9555 12.0088L10.9643 12L10.9555 11.9911L5.88241 6.91805C5.74642 6.78207 5.67673 6.61122 5.67357 6.4046L5.67357 6.40459C5.67041 6.19829 5.73998 6.02434 5.88241 5.88193L5.88241 5.88192C6.02492 5.73941 6.19736 5.66826 6.40047 5.66826C6.60359 5.66826 6.77603 5.73941 6.91854 5.88192L11.9916 10.955L12.0005 10.9638L12.0093 10.955L17.0824 5.88193C17.2184 5.74593 17.3892 5.67624 17.5959 5.67309C17.8022 5.66992 17.9761 5.73949 18.1185 5.88192C18.2611 6.02443 18.3322 6.19687 18.3322 6.39999C18.3322 6.6031 18.2611 6.77554 18.1185 6.91805L13.0455 11.9911L13.0366 12L13.0455 12.0088L18.1185 17.0819C18.2545 17.2179 18.3242 17.3888 18.3274 17.5954C18.3305 17.8017 18.261 17.9756 18.1185 18.118C17.976 18.2606 17.8036 18.3317 17.6005 18.3317C17.3974 18.3317 17.2249 18.2606 17.0824 18.118L12.0093 13.045Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel1);
export default __webpack_public_path__ + "static/media/cancel 1.4c3f9a39be7f5c74fc75b29251add42f.svg";
export { ForwardRef as ReactComponent };